var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMatic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#6F41D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8643 7.13981C11.6567 7.01887 11.3873 7.01887 11.1589 7.13981L9.53944 8.07019L8.43975 8.67656L6.82031 9.60637C6.61275 9.72787 6.34332 9.72787 6.11494 9.60637L4.82794 8.8785C4.62038 8.75756 4.47525 8.53537 4.47525 8.29237V6.85687C4.47525 6.61444 4.59957 6.39225 4.82794 6.27075L6.09356 5.56313C6.30169 5.44162 6.57169 5.44162 6.80006 5.56313L8.06569 6.27075C8.27382 6.39225 8.41894 6.61444 8.41894 6.85687V7.78725L9.51863 7.16006V6.23025C9.51984 6.10948 9.48752 5.99075 9.42525 5.88727C9.36298 5.78378 9.27321 5.69961 9.16594 5.64413L6.82031 4.30987C6.61275 4.18837 6.34332 4.18837 6.11494 4.30987L3.72769 5.64413C3.62042 5.69961 3.53065 5.78378 3.46838 5.88727C3.40611 5.99075 3.37379 6.10948 3.375 6.23025V8.919C3.375 9.162 3.49931 9.38419 3.72769 9.50569L6.11494 10.8399C6.3225 10.9609 6.5925 10.9609 6.82031 10.8399L8.43975 9.92981L9.53944 9.30319L11.1589 8.39362C11.3664 8.27212 11.6359 8.27212 11.8643 8.39362L13.1304 9.10125C13.3386 9.22219 13.4831 9.44438 13.4831 9.68738V11.1229C13.4831 11.3653 13.3594 11.5875 13.1304 11.709L11.8648 12.4369C11.6567 12.5584 11.3867 12.5584 11.1589 12.4369L9.89269 11.7292C9.68457 11.6077 9.53944 11.3856 9.53944 11.1431V10.2127L8.43975 10.8399V11.7697C8.43975 12.0122 8.56406 12.2349 8.79244 12.3559L11.1797 13.6901C11.3873 13.8116 11.6567 13.8116 11.8851 13.6901L14.2723 12.3559C14.4799 12.2349 14.625 12.0127 14.625 11.7697V9.081C14.6262 8.96023 14.5939 8.8415 14.5316 8.73802C14.4694 8.63453 14.3796 8.55036 14.2723 8.49487L11.8648 7.13981H11.8643Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatic);
export default __webpack_public_path__ + "static/media/matic.8915e78b16c0bd95751b34f36ad0c6e6.svg";
export { ForwardRef as ReactComponent };